import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const navLinks = [
  { label: "Overview", href: "#overview" },
  { label: "Amenities", href: "#amenities" },
  { label: "Floor Plans", href: "#floorplans" },
  { label: "Gallery", href: "#gallery" },
  { label: "Location", href: "#location" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl shadow-sm border-b border-[#E8E4D9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" data-testid="navbar-logo" className="flex items-center gap-3">
            <img
              src={scrolled ? "./images/la-valora-logo.jpeg" : "./images/la-valora-logo.jpeg"}
              alt="La Valora Logo"
              className="transition-all duration-300"
              style={{ width: "120px", height: "auto" }}
            />
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`text-sm uppercase tracking-[0.15em] font-medium transition-colors duration-300 hover:text-[#C5A059] ${
                  scrolled ? "text-[#5C5C59]" : "text-white/80"
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+919030145871"
              data-testid="nav-phone-btn"
              className="flex items-center gap-2 bg-[#C5A059] text-white px-5 py-2.5 text-sm uppercase tracking-widest hover:bg-[#B08D4C] transition-colors duration-300"
            >
              <Phone size={14} />
              <span>Call Now</span>
            </a>
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden p-2 transition-colors ${
              scrolled ? "text-[#1A1A1A]" : "text-white"
            }`}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-white/95 backdrop-blur-xl border-t border-[#E8E4D9] px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block text-sm uppercase tracking-[0.15em] text-[#5C5C59] hover:text-[#C5A059] transition-colors py-2"
            >
              {link.label}
            </a>
          ))}
          {/* <a
            href="tel:+919663862557"
            className="flex items-center justify-center gap-2 bg-[#C5A059] text-white px-5 py-3 text-sm uppercase tracking-widest mt-4"
          >
            <Phone size={14} />
            <span>Call Now</span>
          </a> */}
        </div>
      </div>
    </nav>
  );
}
